module.exports = __webpack_public_path__ + "static/img/loading-img.83c2aea.gif";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/loading-img.gif
// module id = LT7l
// module chunks = 1